export default function SmsApi (){
    return (<><div className="main">
  <div className="topbar">
    <div>
      <div className="page-title" id="page-title">
        SMS API
      </div>
      <div className="page-sub" id="page-sub">
        System › SMS API Configuration
      </div>
    </div>
    <div className="topbar-right" id="topbar-right" />
  </div>
  <div className="content" id="content-area">
    <div
      className="cus-grid-054"
      style={{
        display: "grid",
        gridTemplateColumns: "230px 1fr",
        gap: 16,
        alignItems: "start"
      }}
    >
      <div>
        <div
          style={{
            background: "#0F6E56",
            borderRadius: "var(--radius-md)",
            overflow: "hidden",
            marginBottom: 14
          }}
        >
          <div style={{ padding: "12px 14px 4px" }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>
              Replacement Values
            </div>
            <div
              style={{
                fontSize: 10,
                color: "rgba(255,255,255,0.65)",
                textTransform: "uppercase",
                letterSpacing: ".06em",
                marginTop: 2
              }}
            >
              Click 📋 to copy
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(0,0,0,0.28)",
              margin: "3px 8px",
              borderRadius: 5,
              padding: "8px 10px",
              cursor: "pointer"
            }}
            onclick="copyApiVar('TemplateID Replacement')"
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                fontFamily: "monospace"
              }}
            >
              TemplateID Replacement
            </span>
            <span style={{ fontSize: 13, opacity: ".8" }}>📋</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(0,0,0,0.14)",
              margin: "3px 8px",
              borderRadius: 5,
              padding: "8px 10px",
              cursor: "pointer"
            }}
            onclick="copyApiVar('{TO}')"
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                fontFamily: "monospace"
              }}
            >
              {"{"}TO{"}"}
            </span>
            <span style={{ fontSize: 13, opacity: ".8" }}>📋</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(0,0,0,0.14)",
              margin: "3px 8px",
              borderRadius: 5,
              padding: "8px 10px",
              cursor: "pointer"
            }}
            onclick="copyApiVar('{MESSAGE}')"
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                fontFamily: "monospace"
              }}
            >
              {"{"}MESSAGE{"}"}
            </span>
            <span style={{ fontSize: 13, opacity: ".8" }}>📋</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(0,0,0,0.14)",
              margin: "3px 8px",
              borderRadius: 5,
              padding: "8px 10px",
              cursor: "pointer"
            }}
            onclick="copyApiVar('{SENDERNAME}')"
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                fontFamily: "monospace"
              }}
            >
              {"{"}SENDERNAME{"}"}
            </span>
            <span style={{ fontSize: 13, opacity: ".8" }}>📋</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(0,0,0,0.14)",
              margin: "3px 8px",
              borderRadius: 5,
              padding: "8px 10px",
              cursor: "pointer"
            }}
            onclick="copyApiVar('{DLT_TE_ID}')"
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                fontFamily: "monospace"
              }}
            >
              {"{"}DLT_TE_ID{"}"}
            </span>
            <span style={{ fontSize: 13, opacity: ".8" }}>📋</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(0,0,0,0.14)",
              margin: "3px 8px",
              borderRadius: 5,
              padding: "8px 10px",
              cursor: "pointer"
            }}
            onclick="copyApiVar('{APIKEY}')"
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                fontFamily: "monospace"
              }}
            >
              {"{"}APIKEY{"}"}
            </span>
            <span style={{ fontSize: 13, opacity: ".8" }}>📋</span>
          </div>
          <div style={{ height: 10 }} />
        </div>
        <div className="card">
          <div className="card-title">Usage Guide</div>
          <ul
            style={{
              fontSize: 11,
              color: "var(--text-secondary)",
              paddingLeft: 16,
              lineHeight: 2
            }}
          >
            <li>
              <strong>GET:</strong> Add all params in the API URL directly
            </li>
            <li>
              <strong>POST:</strong> Set JSON body + dynamic headers
            </li>
            <li>Click replacement var to copy it</li>
            <li>Paste vars into URL or JSON body</li>
          </ul>
        </div>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 14
          }}
        >
          <div>
            <div style={{ fontSize: 15, fontWeight: 700 }}>📱 SMS API Form</div>
            <div
              style={{
                fontSize: 11,
                color: "var(--text-secondary)",
                marginTop: 2
              }}
            >
              Configure API endpoints for sending SMS messages
            </div>
          </div>
          <button
            className="btn btn-primary"
            onclick="openApiModal('sms',null)"
          >
            + Add New API
          </button>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            marginBottom: 16
          }}
        >
          <div
            style={{
              background: "var(--bg-secondary)",
              border: "0.5px solid var(--border-light)",
              borderRadius: "var(--radius-md)",
              padding: 14,
              display: "flex",
              alignItems: "flex-start",
              gap: 12
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 5,
                  flexWrap: "wrap"
                }}
              >
                <span style={{ fontSize: 13, fontWeight: 600 }}>
                  MSG91 Primary
                </span>
                <span className="badge badge-teal">Default</span>
                <span className="badge badge-active">Active</span>
                <span className="badge badge-info">POST</span>
                <span className="badge badge-gray">All</span>
                <span className="badge badge-gray">JSON</span>
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "var(--text-secondary)",
                  fontFamily: "monospace",
                  wordBreak: "break-all",
                  lineHeight: "1.6"
                }}
              >
                https://api.msg91.com/api/v2/sendsms
              </div>
              <div
                style={{
                  marginTop: 5,
                  fontSize: 10,
                  color: "var(--text-tertiary)"
                }}
              >
                2 header(s) configured
              </div>
            </div>
            <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
              <button className="btn btn-xs" onclick="openApiModal('sms',1)">
                Edit
              </button>
              <button
                className="btn btn-xs btn-danger"
                onclick="toggleApiActive('sms',1)"
              >
                Deactivate
              </button>
              <button
                className="btn btn-xs btn-warn"
                onclick="showToast('Test message sent!','success')"
              >
                Test
              </button>
            </div>
          </div>
          <div
            style={{
              background: "var(--bg-secondary)",
              border: "0.5px solid var(--border-light)",
              borderRadius: "var(--radius-md)",
              padding: 14,
              display: "flex",
              alignItems: "flex-start",
              gap: 12
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 5,
                  flexWrap: "wrap"
                }}
              >
                <span style={{ fontSize: 13, fontWeight: 600 }}>
                  Twilio SMS
                </span>
                <span className="badge badge-gray">Inactive</span>
                <span className="badge badge-info">POST</span>
                <span className="badge badge-gray">Transactional</span>
                <span className="badge badge-gray">JSON</span>
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: "var(--text-secondary)",
                  fontFamily: "monospace",
                  wordBreak: "break-all",
                  lineHeight: "1.6"
                }}
              >
                https://api.twilio.com/2010-04-01/Accounts/{"{"}AccountSID{"}"}
                /Messages.json
              </div>
              <div
                style={{
                  marginTop: 5,
                  fontSize: 10,
                  color: "var(--text-tertiary)"
                }}
              >
                2 header(s) configured
              </div>
            </div>
            <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
              <button className="btn btn-xs" onclick="openApiModal('sms',2)">
                Edit
              </button>
              <button
                className="btn btn-xs btn-success"
                onclick="toggleApiActive('sms',2)"
              >
                Activate
              </button>
              <button
                className="btn btn-xs btn-warn"
                onclick="showToast('Test message sent!','success')"
              >
                Test
              </button>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-title">📱 Quick Test</div>
          <div className="form-grid">
            <div className="form-group">
              <label>Test Mobile Number</label>
              <input type="tel" placeholder="+91 9876543210" />
            </div>
            <div className="form-group">
              <label>Use API</label>
              <select>
                <option>MSG91 Primary</option>
                <option>Twilio SMS</option>
              </select>
            </div>
            <div className="form-group full">
              <label>Test Message</label>
              <input
                type="text"
                defaultValue="Hello! Test from NestManager at 15:04:41"
              />
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <button className="btn btn-primary">Send Test SMS</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</>)
}